module.exports = __webpack_public_path__ + "img/evenly lit.469f753d.png";